export const deskManagementModeKey = 'DESK_MANAGEMENT_MODE';
export const deskTranslationPrefix = 'desk';
